import digitsOnly from './digitsOnly';

export const handleIntegerOnly = (value: unknown): number | '' => {
  const digits = digitsOnly(value);
  return digits ? parseInt(digits, 10) : '';
};
